import { useState } from "react";
import {
  RiFlightTakeoffFill,
  RiFlightLandLine,
  RiCalendar2Line,
  RiTimeLine,
  RiArrowRightLine,
} from "@remixicon/react";

import { Card, CardContent } from "@components/ui/Card";
import StatusBadge from "./StatusBadge";
import FlightDetailDrawer from "./FlightDetailDrawer";
import { formatDateInAirportTimezone, formatTimeInAirportTimezone } from "@/utils/airportTimezone";
import { useNeedsReview } from "@/features/track/utils/needsReview";

const FlightCard = ({ flight }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const needsReview = useNeedsReview(flight);

  if (!flight) return null;

  const formattedDate = formatDateInAirportTimezone(flight.departureDate, flight.route?.from);
  const formattedTime = formatTimeInAirportTimezone(flight.departureDate, flight.route?.from);

  return (
    <>
    <Card
      className="overflow-hidden mb-3 hover:shadow-md transition-shadow !rounded-3xl cursor-pointer"
      onClick={() => setIsDrawerOpen(true)}
    >
      <CardContent className="p-4">
        <div className="mb-3 border-b border-gray-100 pb-3">
          <p>{flight.clientName}</p>
          <div className="flex justify-between">
            <h3 className="text-lg font-semibold text-gray-900">
              {flight.tailNumber}
            </h3>

            <div className="flex items-center gap-2">
              {needsReview && (
                <span className="inline-flex items-center rounded-full bg-amber-100 text-amber-700 text-[10px] font-semibold px-2 py-0.5">
                  Needs review
                </span>
              )}
              <StatusBadge status={flight.status} />
            </div>
          </div>
        </div>

        <div className="flex justify-between">
          <div className="flex items-center gap-2 mb-3">
            <div className="flex items-center gap-1 rounded-full bg-gray-100 px-2 py-1">
              <RiFlightTakeoffFill className="w-4 h-4" />
              <span className="text-sm font-medium">{flight.route.from}</span>
            </div>
            <RiArrowRightLine className="w-5 h-5 text-gray-500" />
            <div className="flex items-center gap-1 rounded-full bg-gray-100 px-2 py-1">
              <RiFlightLandLine className="w-4 h-4" />
              <span className="text-sm font-medium">{flight.route.to}</span>
            </div>
          </div>

          <div className="flex items-center gap-4 text-sm text-gray-600">
            <div className="flex items-center gap-1">
              <RiCalendar2Line className="w-4 h-4" />
              <span>{formattedDate}</span>
            </div>
            <div className="flex items-center gap-1">
              <RiTimeLine className="w-4 h-4" />
              <span>{formattedTime}</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
    <FlightDetailDrawer
      isOpen={isDrawerOpen}
      onClose={() => setIsDrawerOpen(false)}
      flight={flight}
    />
  </>
  );
};

export default FlightCard;
